import { Skeleton, Typography } from '@mui/material';
import { SimplifiedAttioValuation } from 'dashboard409a/services/attio.types';
import { CommonCellProps } from './cells.props';

interface FinancialFieldCellProps extends CommonCellProps {
  fieldKey: keyof SimplifiedAttioValuation;
}

const FinancialFieldCell = ({ valuationRow, fieldKey }: FinancialFieldCellProps) => {
  if (valuationRow.is_loading_additional_data) {
    return <Skeleton variant="text" width="80%" height={20} />;
  }

  const value = valuationRow[fieldKey] as string | null | undefined;
  return (
    <Typography variant="body2">
      {value || '-'}
    </Typography>
  );
};

export default FinancialFieldCell;

